export const ENRICHED_PROFILE = "enriched-user-profile";
